import * as React from "react";
import { inject, observer } from "mobx-react";
import { RouterStore } from "mobx-react-router";
import AccountService, {
  userTypes,
  LoginResult,
} from "../../service/AccountService";
import { styled } from "@mui/material/styles";
import firebase from "firebase/compat/app";
import DeleteIcon from "@mui/icons-material/Delete";

import { notification } from "antd";
import "antd/dist/antd.css";

import {
  Container,
  Paper,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Button,
  Snackbar,
  Tooltip,
  Avatar,
  CircularProgress,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import LogoutButton from "../common/LogoutButton";
import BackIcon from "@mui/icons-material/ArrowBack";
import autobind from "autobind-decorator";
import { action, observable } from "mobx";
import EditIcon from "@mui/icons-material/Edit";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import { withStyles } from "@mui/styles";
import PhoneInput from "react-phone-input-2";
import ClearIcon from "@mui/icons-material/Clear";
import { Form, Input, TagPicker } from "rsuite";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

function validateEmail(email: string): boolean {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
    return true;
  }
  return false;
}

const ProfileContainer = withStyles({
  root: {
    marginTop: "36px",
    paddingLeft: "60px",
  },
  "@media screen and (max-width: 590px)": {
    root: {
      paddingLeft: "16px",
      marginTop: "16px",
    },
  },
})(Container);

const ProfilePaper = withStyles({
  root: {
    fontSize: "larger",
    padding: "20px 24px",
  },
  "@media screen and (max-width: 590px)": {
    root: {
      fontSize: "15px",
      padding: "20px 15px",
      fontWeight: "500",
    },
  },
})(Paper);
const CustomSwitch = withStyles({
  root: {
    width: "78px",
    height: "48px",
  },
  thumb: {
    width: "30px",
    height: "30px",
  },
  track: {
    borderRadius: "120px",
  },
  checked: {
    transform: "translateX(28px) !important",
    WebkitTransform: "translateX(28px) !important",
  },
})(Switch);

const RowElement = styled("div")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  margin: "20px 5px",
  "@media screen and (max-width: 590px)": {
    flexDirection: "column",
  },
});

const DivLable = styled("span")({
  display: "flex",
  alignItems: "center",
  textAlign: "left",
  minWidth: "200px",
  padding: "10px 0px",
  "@media screen and (max-width: 590px)": {
    minWidth: "100px",
  },
});

const DivInfo = styled("div")({
  textAlign: "left",
  minWidth: "200px",
  padding: "10px 0px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  "@media screen and (max-width: 590px)": {
    minWidth: "150px",
    flexDirection: "column",
    color: "#000000AB",
  },
});

const Divider = styled("span")({
  margin: "0px 5px",
  padding: "10px 10px",
  display: "flex",
  alignItems: "center",
});

const SubmitButton = styled(Button)((props) => ({
  margin: "0 20px",
  minWidth: "120px",
}));

const LoaderContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  alignItems: "center",
  justifyContent: "center",
});

type ImageProps = {
  url: string;
};

const PictureUploadPlaceholder = styled("div")<ImageProps>((props: any) => {
  let ret = {
    minWidth: "300px",
    height: "200px",
    backgroundColor: "#EBEEF0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundImage: `url(${props.url}`,
    backgroundSize: "cov",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  };

  //   if(props.url != ""){
  //       ret.backgroundImage = `url(${props.url}`;
  //       ret.backgroundSize = 'cover';
  //       ret.backgroundPosition = 'center';
  //       ret.backgroundRepeat = 'no-repeat';
  //   }
  return ret;
});

const SelectedImage = styled("img")({
  maxWidth: "300px",
  maxHeight: "220px",
  position: "relative",
});

const CustomHelperTextError = () => (
  <div
    style={{
      color: "red",
      display: "flex",
      alignItems: "center",
      margin: "4px 0",
    }}
  >
    <ErrorOutlineOutlinedIcon style={{ marginRight: "4px" }} />
    <span>Incorrect confirmation phrase.</span>
  </div>
);

type ProfileStatus =
  | "LOADING"
  | "NORMAL"
  | "EMAIL_LOADING"
  | "PHONE_LOADING"
  | "SURVEY_NOTIFICATION_LOADING"
  | LoginResult;

type ProfilePageProps = {
  routing?: RouterStore;
  account?: AccountService;
};

@inject("routing")
@inject("account")
@observer
export default class ProfilePage extends React.Component<ProfilePageProps> {
  private _db: firebase.firestore.Firestore;

  @observable
  snackMessage = "";

  @observable
  private _showDeleteModal = false;

  @observable
  private _checkEmptyForm: boolean = false;

  @observable
  selectedPicture: any;

  @observable
  selectedPictureLink: string;

  @observable
  _status: ProfileStatus = "NORMAL";

  @observable
  private _email = "";

  @observable
  private _phoneNumber = "";

  @observable
  private _deleteMessage = "";

  @observable
  isLoading: boolean = false;

  @observable
  enableSurveyNotification: boolean = false;

  @autobind
  handleEmailChange(event: any) {
    this._email = event.target.value;
  }

  @autobind
  handleDeleteMessage(val: any) {
    this._deleteMessage = val;
  }

  @autobind
  handlePhoneChange(value: any) {
    this._phoneNumber = value;
  }

  @autobind
  handleSurveyNotificationChange(event: React.ChangeEvent<HTMLInputElement>) {
    this.enableSurveyNotification = event.target.checked;
  }

  @autobind
  goBack() {
    this.props.account.goBack();
  }

  @autobind
  @action
  async resetPassword() {
    let result = await this.props.account.handlePasswordReset(
      this.props.account.userData.email
    );

    if (result === "SUCCESS") {
      this.snackMessage = "Sent Password Reset Email!";
    } else {
      this.snackMessage = result.toString();
    }
  }

  @autobind
  async handleOnUnsubscribe() {
    //"sub_H8e8DQ382DiTjv"  sk_test_fFyspTXEMeae5fJ7sfGoWh1h
    let subId = this.props.account.userData.subId;
    let response = await fetch(
      `https://api.stripe.com/v1/subscriptions/${subId}`,
      {
        method: "DELETE",
        headers: {
          Authorization: "Bearer sk_test_fFyspTXEMeae5fJ7sfGoWh1h",
        },
      }
    ).then((res) => res.json());
    this.goBack();
  }

  deleteAccountsHandler = async (event: any) => {
    var { account, routing } = this.props;
    event.preventDefault();
    if (this._deleteMessage.trim() === "Delete Permanently") {
      const result = await this.props.account.deleteUserAccount();
      if (result === "SUCCESS") {
        await account.handleLogout();
        if (account.user == null) {
          routing.replace("/login");
        }
      } else {
      }
    } else {
      if (!this._checkEmptyForm) this._checkEmptyForm = true;
      this.isLoading = false;
    }

    // this._showDeleteModal = false;
    // if (result === "DELETE_CONTACTS_SUCCESS") {
    //   this._status = "DELETE_CONTACTS_SUCCESS";
    //   this._showSnackbar = true;
    //   this.resetValues();
    //   this.getContacts();
    //   this._selectedContacts = [];
    // } else {
    //   this._status = "UNKNOWN_ERROR";
    //   this._showDeleteModal = false;
    //   this._showSnackbar = true;
    // }
  };

  @autobind
  async pictureSelect(event): Promise<void> {
    this.selectedPicture = event.target.files[0];
    //let fileName = event.target.files[0].name;
    this.selectedPictureLink = URL.createObjectURL(event.target.files[0]);
    if (this.selectedPicture) {
      await this.saveProfilePicture();
    }
  }

  @autobind
  async saveProfilePicture() {
    this._status = "LOADING";
    let result;
    if (this.selectedPicture && this.selectedPictureLink) {
      result = await this.props.account?.saveUserProfilePic(
        this.selectedPicture
      );
    }
    this._status = "NORMAL";
    if (result == "SUCCESS") {
      this.snackMessage = "Picture saved successfully!";
    } else {
      this.snackMessage = result;
    }
    // this.snackMessage = result;
    // this.props.routing.replace('/profile');
  }

  renderLoading() {
    return (
      <LoaderContainer>
        <CircularProgress />
      </LoaderContainer>
    );
  }

  renderNavBar() {
    return (
      <AppBar position="static">
        <Toolbar variant="dense">
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={this.goBack}
          >
            <BackIcon />
          </IconButton>
          {/* <Avatar style={{backgroundColor: '#3f50b5'}}>
                        <Icon icon={robotIcon} />
                    </Avatar> */}
          <Typography variant="h6" style={{ flexGrow: 1, color: "inherit" }}>
            Profile
          </Typography>
          <LogoutButton />
        </Toolbar>
      </AppBar>
    );
  }

  async componentDidMount() {
    const userId = this.props.account.user.uid;
    if (this.props.account.userData.displayPic) {
      this.selectedPictureLink = this.props.account.userData.displayPic;
    }
    const userData = await firebase
      .firestore()
      .collection("userx")
      .doc(userId)
      .get();
    const user = await userData.data();
    this._phoneNumber = user?.phoneNumber;
    this.enableSurveyNotification = user?.surveyNotification ? true : false;
  }

  async updateEmail(newEmail: string) {
    const newCustomEmail = newEmail.trim();
    if (!validateEmail(newCustomEmail)) {
      notification.error({
        message: "Invalid Email ",
        placement: "bottomRight",
        duration: 5,
      });
      return;
    }
    try {
      this._status = "EMAIL_LOADING";
      const user = firebase.auth().currentUser;
      if (user.email !== newCustomEmail) {
        await user.updateEmail(newCustomEmail);
        this._status = "NORMAL";
        notification.success({
          message: "Email Updated Successfully",
          placement: "bottomRight",
          duration: 5,
        });
        const { account, routing } = this.props;
        await account.handleLogout();

        if (account.user == null) {
          routing.replace("/login");
        }
      } else {
        notification.error({
          message: "Email Already Exists",
          placement: "bottomRight",
          duration: 5,
        });
        this._status = "NORMAL";
      }
    } catch (err) {
      const { message } = err;
      if (err.code == "auth/requires-recent-login") {
        notification.error({
          message: `${message}`,
          placement: "bottomRight",
          duration: 5,
        });
        this._status = "NORMAL";
      }
    }
  }

  async savePhoneNumber(phone: string) {
    const interPhoneNumber = `+${phone}`;
    try {
      // this._status = 'PHONE_LOADING';
      const userId = firebase.auth().currentUser.uid;
      const userData = await firebase
        .firestore()
        .collection("userx")
        .doc(userId)
        .set(
          {
            phoneNumber: interPhoneNumber,
          },
          { merge: true }
        );
      this._status = "NORMAL";
      notification.success({
        message: "Phone number saved Successfully",
        placement: "bottomRight",
        duration: 5,
      });
    } catch (err) {
      const { message } = err;
      if (err.code == "auth/requires-recent-login") {
        notification.error({
          message: `${message}`,
          placement: "bottomRight",
          duration: 5,
        });
        this._status = "NORMAL";
      }
    }
  }
  async updateSurveyNotification() {
    try {
      this._status = "SURVEY_NOTIFICATION_LOADING";
      const userId = firebase.auth().currentUser.uid;
      const userData = await firebase
        .firestore()
        .collection("userx")
        .doc(userId)
        .set(
          {
            surveyNotification: this.enableSurveyNotification,
          },
          { merge: true }
        );
      this._status = "NORMAL";
      notification.success({
        message: "Survey Notification updated Successfully",
        placement: "bottomRight",
        duration: 5,
      });
    } catch (err) {
      const { message } = err;
      if (err.code == "auth/requires-recent-login") {
        notification.error({
          message: `${message}`,
          placement: "bottomRight",
          duration: 5,
        });
        this._status = "NORMAL";
      }
    }
  }

  renderDeleteModal() {
    return (
      <Dialog
        open={this._showDeleteModal}
        style={{ margin: "0 auto" }}
        maxWidth="sm"
        fullWidth={true}
        sx={{
          maxWidth: "600px",
        }}
      >
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>Delete Account</span>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                this._showDeleteModal = false;
              }}
            >
              <ClearIcon />
            </span>
          </div>
        </DialogTitle>
        <DialogContent style={{ padding: "0" }}>
          <Form
            style={{ padding: "2rem 1.3rem", maxWidth: "500px", width: "100%" }}
          >
            <Form.Group>
              <Typography variant="body1">
                We're sorry to see you go!
              </Typography>
              <Typography variant="body1" marginTop="1rem" marginBottom="1rem">
                To confirm your decision, please enter the following phrase
                exactly as shown: <strong>"Delete Permanently"</strong>
              </Typography>
              <Input
                style={{ width: "100%" }}
                placeholder="Delete Permanently"
                onChange={this.handleDeleteMessage}
                disabled={this.isLoading}
                value={this._deleteMessage}
                size="lg"
              />

              {this._checkEmptyForm &&
                this._deleteMessage !== "Delete Permanently" && (
                  <CustomHelperTextError />
                )}
            </Form.Group>
          </Form>
        </DialogContent>
        <DialogActions
          style={{
            padding: "1.5rem 1rem",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            color="inherit"
            onClick={() => {
              this._showDeleteModal = false;
            }}
            size="medium"
            disabled={this.isLoading}
            style={{ height: "40px", margin: "0 1rem" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={(ev: any) => {
              this.isLoading = true;
              this.deleteAccountsHandler(ev);
            }}
            size="medium"
            disabled={this.isLoading}
            style={{ height: "40px", margin: "0 1rem" }}
          >
            {this.isLoading ? (
              <CircularProgress size={18} style={{ color: "inherit" }} />
            ) : (
              "Delete"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    return (
      <React.Fragment>
        <div
          style={{
            width: "100%",
            height: "env(safe-area-inset-top)",
            backgroundColor: "#3f51b5",
          }}
        />
        {this.renderNavBar()}
        <ProfileContainer maxWidth="lg">
          <ProfilePaper elevation={3}>
            <RowElement>
              <DivLable>
                EMAIL<Divider>:</Divider>
              </DivLable>

              {/* <DivInfo>{this.props.account.user?.email}</DivInfo> */}
              <DivInfo>
                <input
                  type="text"
                  disabled={this._status == "LOADING"}
                  style={{
                    padding: "6px 14px",
                    border: "1px solid lightgray",
                    borderRadius: "4px",
                    fontSize: "17px",
                    outline: "none",
                  }}
                  placeholder={this.props.account.user?.email}
                  value={this._email}
                  onChange={this.handleEmailChange}
                />
                <SubmitButton
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={this._status == "EMAIL_LOADING"}
                  onClick={() => this.updateEmail(this._email)}
                >
                  {this._status == "EMAIL_LOADING" ? (
                    <CircularProgress size={18} />
                  ) : (
                    <Typography>UPDATE</Typography>
                  )}
                </SubmitButton>
              </DivInfo>
            </RowElement>
            <RowElement>
              <DivLable>
                PASSWORD<Divider>:</Divider>
              </DivLable>

              <DivInfo>
                *************
                <Tooltip title="Reset Password" placement="bottom">
                  <IconButton
                    edge="end"
                    aria-label="edit"
                    onClick={this.resetPassword}
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>
              </DivInfo>
            </RowElement>
            <RowElement>
              <DivLable>
                PHONE NUMBER<Divider>:</Divider>
              </DivLable>

              {/* <DivInfo>{this.props.account.user?.email}</DivInfo> */}
              <DivInfo>
                <PhoneInput
                  country={"us"}
                  value={this._phoneNumber}
                  disabled={this._status == "PHONE_LOADING"}
                  onChange={this.handlePhoneChange}
                  inputClass="rs-input"
                  inputStyle={{
                    width: "220px",
                    fontSize: "1rem",
                    height: "42px",
                  }}
                  dropdownStyle={{ zIndex: "10000000" }}
                  placeholder={this.props.account.user?.phoneNumber}
                />
                <SubmitButton
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={this._status == "EMAIL_LOADING"}
                  onClick={() => this.savePhoneNumber(this._phoneNumber)}
                >
                  {this._status == "EMAIL_LOADING" ? (
                    <CircularProgress size={18} />
                  ) : (
                    <Typography>SAVE</Typography>
                  )}
                </SubmitButton>
              </DivInfo>
            </RowElement>
            <RowElement>
              <DivLable>
                DISPLAY PICTURE<Divider>:</Divider>
              </DivLable>
              <DivInfo>
                <Avatar
                  style={{ marginRight: "20px" }}
                  alt="A"
                  src={this.selectedPictureLink}
                ></Avatar>

                <label
                  htmlFor="icon-img"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    marginRight: "20px",
                  }}
                >
                  <IconButton component="span">
                    <AddAPhotoIcon />
                  </IconButton>
                  <p
                    style={{
                      color: "#8C8C8C",
                      fontSize: "14px",
                      fontStyle: "Roboto",
                      textAlign: "center",
                    }}
                  >
                    Select Picture
                  </p>
                </label>
                {/* <label style={{marginLeft:'20px'}}>{this.selectedAudioThumbnail?.name}</label> */}
                <input
                  id="icon-img"
                  style={{ display: "none" }}
                  type="file"
                  accept="image/*"
                  name="audioThumbnail"
                  onChange={this.pictureSelect}
                ></input>
                {this._status == "LOADING" ? this.renderLoading() : null}
                {/* <Button
                  variant="contained"
                  color="primary"
                  disabled={!this.selectedPicture}
                  onClick={this.saveProfilePicture}
                  style={{
                    display: "flex",
                    alignSelf: "flex-end",
                    marginLeft: "10px",
                    marginTop: "10px",
                  }}
                ></Button> */}
              </DivInfo>
            </RowElement>
            <RowElement>
              <DivLable>
                CURRENT PLAN<Divider>:</Divider>
              </DivLable>

              <DivInfo>{`${
                this.props.account.userData.userType.split("_")[0]
              } PLAN`}</DivInfo>
            </RowElement>
            {this.props.account.userData?.userType !== "FREE_USER" && (
              <RowElement>
                <DivLable>
                  SURVEY NOTIFICATION<Divider>:</Divider>
                </DivLable>
                <DivInfo>
                  <CustomSwitch
                    checked={this.enableSurveyNotification}
                    onChange={this.handleSurveyNotificationChange}
                    inputProps={{ "aria-label": "controlled" }}
                    disabled={this._status == "LOADING"}
                  />
                  <SubmitButton
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={this._status == "SURVEY_NOTIFICATION_LOADING"}
                    onClick={() => this.updateSurveyNotification()}
                  >
                    {this._status == "SURVEY_NOTIFICATION_LOADING" ? (
                      <CircularProgress size={18} />
                    ) : (
                      <Typography>UPDATE</Typography>
                    )}
                  </SubmitButton>
                </DivInfo>
              </RowElement>
            )}

            <RowElement>
              <DivLable>
                CHANGE PLAN<Divider>:</Divider>
              </DivLable>

              {this.props.account.userData.userType === userTypes.FREE_USER ? (
                <DivInfo>
                  <Button
                    style={{ margin: "10px" }}
                    variant="contained"
                    color="primary"
                    onClick={() => this.props.routing.push("/plan")}
                  >
                    UPGRADE
                  </Button>
                </DivInfo>
              ) : this.props.account.userData.userType ===
                userTypes.STANDARD_USER ? (
                <DivInfo>
                  <Button
                    style={{ margin: "10px" }}
                    variant="contained"
                    color="primary"
                    onClick={() => this.props.routing.push("/plan")}
                  >
                    UPGRADE
                  </Button>
                  <Button
                    style={{ margin: "10px" }}
                    variant="contained"
                    color="secondary"
                    onClick={this.handleOnUnsubscribe}
                  >
                    UNSUBSCRIBE
                  </Button>
                </DivInfo>
              ) : (
                <DivInfo>
                  <Button
                    style={{ margin: "10px" }}
                    variant="contained"
                    color="secondary"
                    onClick={this.handleOnUnsubscribe}
                  >
                    UNSUBSCRIBE
                  </Button>
                </DivInfo>
              )}
              <DivInfo>{this.props.account.userData.subId}</DivInfo>
            </RowElement>
            <Button
              variant="contained"
              color="error"
              onClick={() => (this._showDeleteModal = true)}
              style={{ marginBottom: "12px" }}
            >
              <DeleteIcon style={{ marginRight: "6px" }} />
              Delete Account
            </Button>
          </ProfilePaper>

          <Snackbar
            open={this.snackMessage ? true : false}
            autoHideDuration={6000}
            onClose={() => (this.snackMessage = null)}
          >
            <div
              style={{
                backgroundColor: "orange",
                color: "white",
                padding: "10px",
                borderRadius: "5px",
              }}
            >
              {this.snackMessage}
            </div>
            {/* <MuiAlert elevation={6} variant="filled" severity="info" onClose={()=>this.snackMessage=null}>{this.snackMessage}</MuiAlert> */}
          </Snackbar>
        </ProfileContainer>
        {this.renderDeleteModal()}
      </React.Fragment>
    );
  }
}
